
const [START, SUCCESS, FAIL] = ['START', 'SUCCESS', 'FAIL'];
const [PENDING, FULFILLED, REJECTED] = ['PENDING', 'FULFILLED', 'REJECTED'];

export const PROMISE_TYPE_SUFFIXES = [PENDING, FULFILLED, REJECTED];
export const REQUEST_TYPE_SUFFIXES = [START, SUCCESS, FAIL];

export const PROMISE_TYPE_DELIMITER = '_';

export const createActionWithTypes = (base, types) => {
  let obj = {__BASE:base};
  types.forEach( type => {
    obj[type] = `${base}${PROMISE_TYPE_DELIMITER}${type}`;
  });
  return obj
}

export const createRequestTypes = (base, addTypes = []) => { return createActionWithTypes(base, new Set([...REQUEST_TYPE_SUFFIXES, ...addTypes])); }
// function createPromiseTypes(base) { return createActionWithTypes(base, PROMISE_TYPE_SUFFIXES); }




export const REQUEST_FAIL = 'REQUEST_FAIL';


// FORMS
export const FORM_SUBMIT = createRequestTypes('FORM_SUBMIT');
export const UPDATE_FORM_STATE = 'UPDATE_FORM_STATE';

// COMMON
export const APP_LOAD = createRequestTypes('APP_LOAD');
export const HELLO_WORLD = createRequestTypes('HELLO_WORLD');
export const REDIRECT = 'REDIRECT';
export const REDIRECT_TO = 'REDIRECT_TO';


// PROJECTS
export const LOAD_PROJECT = createRequestTypes('LOAD_PROJECT');
export const FETCH_PROJECTS = createRequestTypes('FETCH_PROJECTS');
export const CREATE_PROJECT = createRequestTypes('CREATE_PROJECT');
export const UPDATE_PROJECT = createRequestTypes('UPDATE_PROJECT');
export const DESTROY_PROJECT = createRequestTypes('DESTROY_PROJECT');

// MEMBERS
export const CREATE_MEMBER = createRequestTypes('CREATE_MEMBER');
export const DESTROY_MEMBER = createRequestTypes('DESTROY_MEMBER');

// DOMAINS
export const CREATE_DOMAIN = createRequestTypes('CREATE_DOMAIN');
export const UPDATE_DOMAIN = createRequestTypes('UPDATE_DOMAIN');
export const DESTROY_DOMAIN = createRequestTypes('DESTROY_DOMAIN');



// AUTH
export const LOGIN = createRequestTypes('LOGIN', ['UNLOAD']);
export const REGISTRATION = createRequestTypes('REGISTRATION', ['UNLOAD']);
export const LOGOUT = 'LOGOUT';
export const LOAD_PROFILE = createRequestTypes('LOAD_PROFILE');
export const RELOAD_PROFILE = createRequestTypes('RELOAD_PROFILE');
export const UPDATE_PROFILE = createRequestTypes('UPDATE_PROFILE');


// MONEY 
export const UPDATE_SUBSCRIPTION = createRequestTypes('UPDATE_SUBSCRIPTION');
export const UPDATE_PAYMENT_METHOD = createRequestTypes('UPDATE_PAYMENT_METHOD');

// COUPON 
export const REDEEM_COUPON = createRequestTypes('REDEEM_COUPON');


// FTE
export const FTE_SUCCESS = 'FTE_SUCCESS';


// PIXEL SETS
export const FETCH_PIXEL_SETS = createRequestTypes('FETCH_PIXEL_SETS', ['UNLOAD']);
export const FETCH_PIXEL_SET = createRequestTypes('FETCH_PIXEL_SET', ['UNLOAD']);
export const CREATE_PIXEL_SET = createRequestTypes('CREATE_PIXEL_SET');
export const UPDATE_PIXEL_SET = createRequestTypes('UPDATE_PIXEL_SET');
export const DESTROY_PIXEL_SET = createRequestTypes('DESTROY_PIXEL_SET');


// LINKS
export const FETCH_LINKS = createRequestTypes('FETCH_LINKS');
export const FETCH_LINK = createRequestTypes('FETCH_LINK');
export const CREATE_LINK = createRequestTypes('CREATE_LINK');
export const UPDATE_LINK = createRequestTypes('UPDATE_LINK');
export const DESTROY_LINK = createRequestTypes('DESTROY_LINK');
export const REMOVE_LINK_PIXEL_SET = createRequestTypes('REMOVE_LINK_PIXEL_SET');


// TAGS
export const FETCH_TAGS = createRequestTypes('FETCH_TAGS');


// Modals
export const MODAL_OPEN = 'MODAL_OPEN';
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const MODAL_REPLACE_ALL = 'MODAL_REPLACE_ALL';
export const MODAL_CLOSE_ALL = 'MODAL_CLOSE_ALL';

// Notifications
export const FETCH_NOTIFICATIONS = createRequestTypes('FETCH_NOTIFICATIONS');
export const DESTROY_NOTIFICATION_MESSAGE = createRequestTypes('DESTROY_NOTIFICATION_MESSAGE');


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js